/**
 * DEV-258 — projeção da definição do formulário (contracts/form-definition.md).
 * O cliente NÃO guarda lista de etapas, campos ou obrigatoriedade: tudo vem
 * daqui (FR-009).
 */
export type StandardPageName =
  | 'identificacao_vaga'
  | 'remuneracao'
  | 'formacao'
  | 'perfil_candidato'
  | 'descritivos';

export interface DefinitionQuestion {
  name: string;
  title: string;
  /** Tipo SurveyJS da pergunta no template (`text`, `tagbox`, `checkbox`…). */
  type: string;
  /** Opções do template (enumerações fechadas); `null` = lista vem da base. */
  choices: string[] | null;
}

export interface StandardFormPage {
  kind: 'standard';
  /** Um dos `StandardPageName` (o Core tipa como string). */
  name: StandardPageName | (string & {});
  title: string;
  questions: DefinitionQuestion[];
}

export interface CustomFormPage {
  kind: 'custom';
  name: string;
  title: string;
  survey: Record<string, unknown>;
  questionNames: string[];
  requiredQuestionNames: string[];
}

export type FormPage = StandardFormPage | CustomFormPage;

export interface FormDefinition {
  program: { id: string; name: string; logoUrl: string | null };
  contractTypes: { key: string | null; label: string }[];
  requiredByContractType: Record<string, string[]>;
  requiredDefault: string[];
  pages: FormPage[];
  protectedQuestions: string[];
}

export interface JobDescription {
  id: string;
  status: 'draft' | 'submitted';
  programId: string;
  manager: { name: string; email: string };
  answers: Record<string, unknown>;
  submittedAt: string | null;
  updatedAt: string;
}

export function firstPageName(definition: FormDefinition): string | null {
  return definition.pages[0]?.name ?? null;
}
